import React, { useState } from "react";
import MainCard from "components/MainCard";
import ThemeInput from "components/inputs/ThemeInput";
import {
    Grid,
    InputLabel,
    Select,
    MenuItem,
    FormControl,
    Stack,
    OutlinedInput,
    Button, InputAdornment
} from "@mui/material";
import { Spin } from "antd";
import { toast } from "react-toastify";
import { useDispatch, connect } from "react-redux";
import { EditTenant, AddTenant } from "store/action/index";
import { useLocation, useNavigate } from "react-router-dom";

// ==============================|| TENANT MANAGEMENT - ADD/EDIT TENANT ||============================== //

const AddTenants = ({ allTenants }) => {
    const location = useLocation();
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const [domain, setDomain] = useState(location.state?.domain || "");
    const [plan, setPlan] = useState(location.state?.plan || "monthly_percent");
    const [status, setStatus] = useState(location.state?.status || "active");
    const [dbName, setDbName] = useState(location.state?.db_name || "");
    const [price, setPrice] = useState(location.state?.price || ""); // ✅ new field
    const [loading, setLoading] = useState(false);

    const handleSubmit = () => {
        if (domain && plan && status && dbName && price) {
            const payload = {
                domain,
                plan,
                status,
                db_name: dbName,
                price, // ✅ include price
                ...(location.state?.id && { id: location.state.id }),
            };
            const navigateBack = () => {
                navigate("/tenants/all-tenants");
            }
            if (location.state) {
                dispatch(EditTenant({ payload, setLoading, navigateBack }));
            } else {
                dispatch(AddTenant({ payload, setLoading, navigateBack }));
            }
        } else {
            toast.error("Required Fields are empty", {
                position: "top-right",
                autoClose: 3000,
            });
        }
    };

    return (
        <MainCard>
            <Spin spinning={loading}>
                <Grid container spacing={2}>
                    {/* Domain */}
                    <Grid item xs={12} md={4}>
                        <Stack spacing={1}>
                            <InputLabel htmlFor="domain" style={{ fontSize: "13px" }}>
                                Domain*
                            </InputLabel>
                            <OutlinedInput
                                id="domain"
                                value={domain}
                                onChange={(e) => setDomain(e.target.value)}
                                placeholder="example.com"
                                fullWidth
                                startAdornment={
                                    <InputAdornment position="start">https://</InputAdornment>
                                }
                            />
                        </Stack>
                    </Grid>

                    {/* Plan */}
                    <Grid item xs={12} md={4}>
                        <Stack spacing={1}>
                            <InputLabel id="plan-label" style={{ fontSize: "13px" }}>
                                Plan*
                            </InputLabel>
                            <FormControl variant="outlined" fullWidth>
                                <Select
                                    labelId="plan-label"
                                    value={plan}
                                    onChange={(e) => setPlan(e.target.value)}
                                    input={<OutlinedInput />}
                                    style={{ height: "52px" }}
                                >
                                    <MenuItem value="monthly_percent">Monthly Percent</MenuItem>
                                    <MenuItem value="monthly_fixed">Monthly Fixed</MenuItem>
                                    <MenuItem value="one_time">One Time</MenuItem>
                                    <MenuItem value="yearly_fixed">Yearly Fixed</MenuItem>
                                    <MenuItem value="yearly_percent">Yearly Percent</MenuItem>
                                </Select>
                            </FormControl>
                        </Stack>
                    </Grid>

                    {/* Status */}
                    <Grid item xs={12} md={4}>
                        <Stack spacing={1}>
                            <InputLabel id="status-label" style={{ fontSize: "13px" }}>
                                Status*
                            </InputLabel>
                            <FormControl variant="outlined" fullWidth>
                                <Select
                                    labelId="status-label"
                                    value={status}
                                    onChange={(e) => setStatus(e.target.value)}
                                    input={<OutlinedInput />}
                                    style={{ height: "52px" }}
                                >
                                    <MenuItem value="active">Active</MenuItem>
                                    <MenuItem value="inactive">Inactive</MenuItem>
                                </Select>
                            </FormControl>
                        </Stack>
                    </Grid>

                    {/* DB Name */}
                    <Grid item xs={12} md={4}>
                        <ThemeInput
                            id="db_name"
                            value={dbName}
                            onChange={(e) => setDbName(e.target.value)}
                            type="text"
                            name="DB Name*"
                            placeholder="Enter DB Name"
                        />
                    </Grid>

                    {/* Price */}
                    <Grid item xs={12} md={4}>
                        <ThemeInput
                            id="price"
                            value={price}
                            onChange={(e) => setPrice(e.target.value)}
                            type="number"
                            name="Price*"
                            placeholder="Enter Price"
                        />
                    </Grid>

                    {/* Submit Button */}
                    <Grid item xs={12}>
                        <div style={{ textAlign: "end" }}>
                            <Button
                                onClick={handleSubmit}
                                disableElevation
                                size="medium"
                                type="submit"
                                variant="contained"
                                color="primary"
                                style={{ color: "white" }}
                            >
                                {location.state ? "Update Tenant" : "Add Tenant"}
                            </Button>
                        </div>
                    </Grid>
                </Grid>
            </Spin>
        </MainCard>
    );
};

const mapStateToProps = (state) => ({
    allTenants: state?.AllTenantsReducer?.allTenants,
});

export default connect(mapStateToProps)(AddTenants);
